export enum DayOfWeekType {
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
  HOLIDAY = "HOLIDAY",
}

export const dayOfWeekMap: Record<DayOfWeekType, { weekDay: number; name: string }> = {
  [DayOfWeekType.MONDAY]: { weekDay: 1, name: "월요일" },
  [DayOfWeekType.TUESDAY]: { weekDay: 2, name: "화요일" },
  [DayOfWeekType.WEDNESDAY]: { weekDay: 3, name: "수요일" },
  [DayOfWeekType.THURSDAY]: { weekDay: 4, name: "목요일" },
  [DayOfWeekType.FRIDAY]: { weekDay: 5, name: "금요일" },
  [DayOfWeekType.SATURDAY]: { weekDay: 6, name: "토요일" },
  [DayOfWeekType.SUNDAY]: { weekDay: 7, name: "일요일" },
  [DayOfWeekType.HOLIDAY]: { weekDay: 8, name: "공휴일" },
};